module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOS45OCAyOS45OCI+PHRpdGxlPmRpYW1vbmQ8L3RpdGxlPjxwYXRoIGQ9Ik0wLDE1LDE1LDAsMzAsMTUsMTUsMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4wMSAtMC4wMSkiIHN0eWxlPSJmaWxsOiMyODJmNGEiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/diamond.svg
// module id = 822
// module chunks = 0